import { makeSelectors } from '@utils/css';

const crossFadeDurationMs = 200;
const modifiers = makeSelectors({
  isPlaying: "_vci9dzp3m"
});
const wrapper = "_vcw1ffiupw";
const imageWrapper = "_vci19w9kaf";
const button = "_vcbew5khe";
const icon = "_vci1e032m";
const asyncProgressCircle = "_vca16a52zi";

export { asyncProgressCircle, button, crossFadeDurationMs, icon, imageWrapper, modifiers, wrapper };
import "./atom.left-graphic.style.linaria.module.css";
//# sourceMappingURL=atom.left-graphic.style.js.map
